<template>
  <div class="row" style="margin-top:15px">

    <div class="col-sm-12">
      <div class="form-group">
        <strong class="control-label">Agent primaire</strong><br>
        <select v-model="serviceprovider.responsable" class="form-control" v-on:change="save()">
          <option value=0>Aucun</option>
          <option v-for="option in responsable_options" :value="option.user_id"
            :key="option.user_id">
            {{ option.responsable_name }}
          </option>
        </select>
      </div>
    </div>
    <div class="col-sm-12" style="margin-top:15px">
      <div class="form-group">
        <strong class="control-label">
          Billets ouverts <router-link :to="{ name: 'liste_billets', query: {ticket_resolution: 'open', service_provider_id: $route.params.service_provider_id} }">({{ticket_count}})</router-link></strong><br>
        <div class="ticket" v-for="ticket in tickets" :key="ticket.ticket_id">
          <router-link  :to="{ name: 'billet', params: { ticket_id: ticket.ticket_id }}">
            <priority-icon v-if="ticket.priority" :priority="ticket.priority"></priority-icon>
            #{{ticket.ticket_id}}&nbsp;-&nbsp;{{ticket.title}}
          </router-link>
          <small v-if="ticket.due_date"
            class="ticket-due-date text-muted"
            :class="{ 'text-danger': isDatePassed(ticket.due_date), 'text-dark': isDateSoon(ticket.due_date) }"
          >(échéance {{moment(ticket.due_date).format('YYYY-MM-DD')}})</small>
        </div>
      </div>
    </div>
    <div class="col-sm-12" style="margin-top:15px">
      <div class="form-group">
        <strong class="control-label">
          Notes <router-link :to="{ name: 'liste_billets', query: {type_key: 'note', service_provider_id: $route.params.service_provider_id} }">({{note_count}})</router-link></strong><br>
        <div v-for="note in notes" :key="note.ticket_id">
          <router-link :to="{ name: 'billet', params: { ticket_id: note.ticket_id}}">#{{note.ticket_id}}&nbsp;-&nbsp;{{note.title}}</router-link>
          <br>
        </div>
      </div>
    </div>
    <div class="col-sm-12" style="margin-top:15px">
      <strong class="control-label">Contact</strong><br>
      <div class="form-group" style="word-break: break-all" v-for="(contact, i) in contacts" :key="i">
        {{contact.first_name}} {{contact.last_name}}<br>
        <template v-if="contact.position">{{contact.position}}<br></template>
        <template v-if="contact.telephone">{{contact.telephone}}<br></template>
        <template v-if="contact.email"><a :href="'mailto:'+contact.email">{{contact.email}}</a></template>
      </div>
    </div>
    <div class="col-sm-12" style="margin-top:15px">
      <div class="form-group">
        <strong class="control-label"><a :href="oziweb_wp_url" target="_blank"><em class="fas fa-book fa-spacer" aria-hidden="true"></em>Rapport {{serviceprovider.period}}</a> :</strong> {{serviceprovider.plan_status}}
      </div>
    </div>
    <div class="col-sm-12" style="margin-top:15px">
      <div class="form-group">
        <strong class="control-label">Statut de désignation : </strong>{{serviceprovider.agency_status}}
      </div>
    </div>

    <div class="col-sm-12" style="margin-top:15px" v-show="serviceprovider.showsuperadmin">
      <div class="form-group">
        <strong class="control-label">Statut du fournisseur : </strong><br>
        <select v-model="serviceprovider.state" class="form-control"  v-on:change="save()">
          <option value="1">Actif</option>
          <option value="0">Inactif</option>
        </select>
      </div>
    </div>

  </div>
</template>

<style scoped>
.ticket {
  margin-bottom: 0.5em;
}

.ticket-due-date {
  display: block;
  line-height: 1;
}
</style>

<script>

import axios from 'axios';
import PriorityIcon from './PriorityIcon.vue'

export default {
  props: ['oziweb_wp_url'],
  components: {
    PriorityIcon
  },
  data: function() {return {
    serviceprovider:'',
    tickets:[],
    ticket_count: 0,
    notes:[],
    note_count: 0,
    contacts:{},
    responsable_options:{},
  }},

  methods: {

    refresh: function() {
      axios
        .get(this.$root.$data.server_base + '/api/service_provider_right_col.php',
          { params: {service_provider_id: this.$route.params.service_provider_id}})
        .then(response => (
          this.serviceprovider = response.data.serviceprovider,
          this.tickets = response.data.tickets,
          this.ticket_count = response.data.ticket_count,
          this.notes = response.data.notes,
          this.note_count = response.data.note_count,
          this.contacts = response.data.contacts,
          this.responsable_options = response.data.responsable
        ))
    },
    save: function()
    {
      axios
        .get(this.$root.$data.server_base + '/api/service_provider_save.php',
          { params:{service_provider_id:this.$route.params.service_provider_id,responsable:this.serviceprovider.responsable,state:this.serviceprovider.state}})

    },
    isDatePassed(dateStr) {
      return this.moment.utc(dateStr).isBefore(this.moment().subtract(1, 'days'))
    },
    isDateSoon(dateStr) {
      return !this.isDatePassed(dateStr) && this.moment.utc(dateStr).isBefore(this.moment().add(5, 'days'))
    }
  },
  mounted () {
    this.refresh();
  }
}
</script>
